<template>
	<div id="message-box">
		<div class="con-ms-message-box" v-if="isShowMessage">
			<div class="message-center">
				<div class="ms-message-bg"></div>
				<div class="ms-message-box-v2" :style="[{ width: option.width }]" :class="option.classContent">
					<div
						class="ms-header-message-box-v2 flex items-center justify-between"
					>
						<div
							class="ms-title-message-box title-header-form ms-line-height-22px"
							v-if="option.title"
						>
							{{ option.title }}
						</div>
						<div
							class="cursor-pointer"
							v-if="option.isIconClose"
							@click="btnCloseClick"
						>
							<div
								class="mi-new-v2 mi-16 mi-icon-v2-close-msg-box"
								:title="$t('i18nCommon.Close')"
							></div>
						</div>
					</div>
					<div class="ms-content-message-box-v2 ms-mgb-16px">
						<div
							class="ms-mgt-16px flex ms-line-height-20px"
							:class="[
								option && option.classMessageContent
									? option.classMessageContent
									: '',
								option && option.isMinHeightDynamic ? '' : 'ms-minH-40px',
							]"
						>
							<div
								id="idMessage"
								class="message font-size-content"
								:class="[
									option.maxHeightMessage ? option.maxHeightMessage : '',
								]"
								v-if="option.message"
								v-html="message"
							></div>
							<div
								class="mess-link"
								v-if="option.messageDetail && !showMessageDetail"
								@click="showMessageDetail = true"
							>
								<div class="mi mi-14 mi-chevron-down--primary-small"></div>
								<div>{{ $t('i18nCommon.ExpandTooltip') }}</div>
							</div>
							<span v-if="option.messageDetail">
								&nbsp;{{ option.messageDetail }}
								<div
									class="mess-link"
									v-if="option.messageDetail && showMessageDetail"
									@click="showMessageDetail = false"
								>
									<div class="mi mi-14 mi-chevron-up--primary-small"></div>
									<div>{{ $t('i18nCommon.CollapseTooltip') }}</div>
								</div>
							</span>
							<component
								v-if="option.optionsCustom && option.optionsCustom.template"
								:is="option.optionsCustom.template"
								v-bind="option.optionsCustom.props"
								v-on="option.optionsCustom.templateEvent"
							></component>
						</div>
					</div>
					<div
						class="ms-footer-message-box-v2"
						v-on:keydown="footerKeydown"
						v-if="showButton"
					>
						<div
							:class="[button.target]"
							v-for="button in listBtn"
							:key="button.key"
						>
							<ms-button
								:class="button.class"
								:style="button.style"
								class="min-width-btn"
								@keydown="escAction"
								:type="button.typeButton"
								:ref="button.focus ? 'btnFocus' : 'btnOther'"
								@click="btnClick(button)"
								:title="button.text"
								:icon="button.icon"
							></ms-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import commonFunc from '@/common/commonFunction';
export default {
	name: 'MsMessageBoxV2',
	props: {
		// chiều rộng của messagebox
		width: {
			type: String,
			default: '432px',
		},
		// option cấu hình messageBox
		option: {
			type: Object,
			default: null,
		},
	},
	computed: {
		listBtn() {
			return this.option.btnConfig.filter((x) => x.hasBtn == true);
		},
		getStyle() {
			const me = this;
			if (!me.option || !me.option.maxHeight) {
				return {};
			}
			return { 'max-height': me.option.maxHeight + 'px !important' };
		},
	},
	data() {
		let showButton = false;
		for (let i = 0; i < this.option.btnConfig.length; i++) {
			if (this.option.btnConfig[i].hasBtn) {
				showButton = true;
				break;
			}
		}

		return {
			isShowMessage: true,
			showMessageDetail: false,
			message: '',
			showButton: showButton,
		};
	},
	methods: {
		/**
		 * Bắt sự kiện click vào button
		 */
		btnClick(button) {
			let key = button.key;
			if (key != 'PermissionGuild') {
				this.isShowMessage = false;
			}
			if (button.callback) {
				button.callback();
			} else {
				this.$emit('btnClick', this, key);
			}
		},
		escapeContent(htmlContent) {
			//Thay đổi toàn bộ kí tự đặc biệt `<`, `>` sang ký hiệu tương ứng để không bị ảnh hưởng việc hiển thị html
			return htmlContent.replace(/>/g, '&gt;').replace(/</g, '&lt;');
		},
		escAction(e) {},
		footerKeydown(e) {
			const me = this;
			commonFunc.processUnfocusLastControl(e, function () {
				commonFunc.focusFirstControl(me.$el);
			});
		},
		linkActive_OnClick() {
			this.$emit('linkActive');
			if (this.option.closeMessageAfterLink) {
				this.isShowMessage = false;
			}
		},
		linkPopup_OnClick() {
			this.$emit('linkPopup');
			this.isShowMessage = false;
		},
		btnCloseClick() {
			const me = this;
			me.isShowMessage = false;
			me.$emit('btnCloseClick');
		},
	},
	mounted() {
		//Focus
		if (this.$refs['btnFocus']) {
			this.$refs['btnFocus'][0].$el.focus();
		} else {
			let primaryBtn = this.$el.querySelector('.ms-button-primary');
			if (primaryBtn) {
				primaryBtn.focus();
			} else {
				commonFunc.focusFirstControl(this.$el);
			}
		}

		// hiện thị text ra message box
		let tt = document.getElementById('idMessage');
		if (this.option.message != '' && tt != null) {
			// nếu truyền thml thì vẫn để thế còn truyền text thì chuyển lại thành ký từ đặc biệt để nó không bị biến thành html khi hiển thị
			if (
				/<(?=.*? .*?\/ ?>|br|hr|input|!--|wbr)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i.test(
					this.option.message
				)
			) {
				tt.innerHTML = this.option.message;
			} else {
				this.message = this.option.message;
			}
		}

		let linkActive = this.$el.querySelector('.link-active'),
			linkPopup = this.$el.querySelector('.link-open-popup');

		if (linkActive !== null) {
			linkActive.addEventListener('click', this.linkActive_OnClick);
		}
		if (linkPopup !== null) {
			linkPopup.addEventListener('click', this.linkPopup_OnClick);
		}
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msMessageBoxV2.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msMessageBoxV2.scss';
}
</style>
